/**
 * Whether this operator may run the device support actions (#1542).
 *
 * The server's bar is the TechSupport role: AdminDevicesController and NodeShellPasswordsController
 * both carry [Authorize(Roles = "TechSupport")]. This answers the same question from the roles
 * react-admin holds, so a control is hidden rather than shown and then refused.
 *
 * Deliberately NOT a check for node administrator. "Administrator" in this program is a rung on
 * the per-node access ladder, not a server role, and a node administrator does not reach the
 * admin console at all.
 *
 * Unknown shapes answer false. authProvider.getPermissions degrades to "no roles" when the stored
 * user cannot be parsed, and a console with nothing privileged on it is the correct degradation -
 * the server refuses the call either way, so guessing true only produces an audited 403.
 */
export const SUPPORT_ROLE = 'TechSupport';

export const hasSupportRole = (permissions: unknown): boolean => {
    if (Array.isArray(permissions)) {
        return permissions.some(
            role => typeof role === 'string' && role.toLowerCase() === SUPPORT_ROLE.toLowerCase(),
        );
    }

    // A single role may arrive as a bare string rather than a one-element array.
    if (typeof permissions === 'string') {
        return permissions.toLowerCase() === SUPPORT_ROLE.toLowerCase();
    }

    return false;
};
